export const COMMENT_FORM_ROLE_FORM = 'form';
export const COMMENT_FORM_ROLE_BUTTON = 'button';

export const COMMENT_PLACEMENT_DEFAULT = null;
export const COMMENT_PLACEMENT_FILTERS = 'filters';

export const SUBTITILE_COMMENT_DECORATIONS_DEFAULT = 'decorations-default';
export const SUBTITILE_COMMENT_DECORATIONS_QUOTE = 'decorations-quote';
